/**
 * Contact Service
 * To construct the template for Call Us page and Email Page
 * Left Side: Email/CallUs
 * Right Side: Find Quick Answers
 */

import React from 'react';
import PropTypes from 'prop-types';
import ErrorHandler from '../containers/ErrorHandler';
import AlertsContainer from '../containers/Alerts';

import * as Page from '../../lib/page';

// Constants
const { error: { contact } } = Page.getLocaleContent('Error');

const ContactService = props => (
  <ErrorHandler contactError={contact}>
    <div className="page-main-container" role="main">
      <AlertsContainer />
      <div className="contact-service-container">
        <div className="col-sm-12 col-md-6 col-lg-6 contact-left-container">
          { props.leftPanel }
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 contact-right-container">
          { props.rightPanel }
        </div>
      </div>
    </div>
  </ErrorHandler>
);

// Contact Service PropTypes
ContactService.propTypes = {
  leftPanel: PropTypes.element.isRequired,
  rightPanel: PropTypes.element.isRequired,
};

export default ContactService;
